import React, { useState, useEffect } from "react";
import {
  DialogContent,
  Card,
  DialogActions,
  Button,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  CardContent,
  Grid,
  IconButton,
} from "@material-ui/core";
import Colors from "shared/color";
import CustomInput from "components/custom/CustomInput";
import { toastSuccess, toastWarning,toastError } from "shared/utils";
import { getUserBankAccounts,createRefundEntry, getBanks, updateRefundBank } from "shared/api";
import MNativeSelect from "components/ui/MNativeSelect";
import Spin from "components/ui/Spin";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import InputField from "components/ui/form/InputField";
import Select from "react-select";
import {isMobile } from "react-device-detect";
import CloseIcon from "@material-ui/icons/Close";



const TCell = (props) => {
  return (
    <TableCell
      style={{
        border: "none",
        fontSize: "0.8125rem",
        padding: " 3px",
        ...props.style,
      }}
    >
      {props.children}
    </TableCell>
  );
};



export const RefundDialog = ({ handleClose, data,bankAccountDetails,mode,refund_reference_number,isRefundView}) => {
  const Schema = Yup.object().shape({
    refund_amount: Yup.string().required("Amount field is required!"),
    refund_amount: Yup.number().max(data["extra_payment_amount"]),
    user_bank_reference_number: Yup.string()
    .nullable()
    .when('refund_mode_requested', {
      is: 'NEFT',
      then: Yup.string()
        .required('Bank details is required for NEFT transfers')
        .test('neft-validation', '', function(value) {
          return this.parent.refund_mode_requested === 'NEFT' 
            ? !!value 
            : true;
        }),
      otherwise: Yup.string().nullable()
    })
  });

  const addBankSchema = Yup.object().shape({
      bank_account_no: Yup.string()
      .required("Bank account_no field is required!")
      .min(5, "Bank account number must be at least 5 digits")
      .matches(/^\d+$/, "Bank account number must contain only digits"),
    bank_account_holder_name: Yup.string()
    .required("Account holder name field is required")
    .max(50, "Account holder name cannot exceed 50 characters")
    .matches(/^[A-Za-z\s]+$/, "Account holder name should contain only alphabets"),
      bank_branch_ifsc: Yup.string().matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'Invalid IFSC code format').required("Bank branch ifsc field is required"),
    });

  const [bankAccounts, setBankAccounts] = useState({});
  const [userBankReferenceNumber, setUserBankReferenceNumber] = useState("")
  const [openAddBankDetails, setOpenAddBankDetails] = useState(false)
  const [bankInfo, setBankInfo] = useState(null);
  
  
  const customStyles = {
    control: base => ({
      ...base,
      height: isMobile ? '40px' : '49px',      
      minHeight: '49px',   
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999, 
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999,
    }),
    placeholder: (base) => ({
      ...base,
      color: "#64748B",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "500",
      lineHeight: '100%'
    }),
  };

  const ErrorText = (props) => <span style={{width: "100%", marginTop: "0.25rem", fontSize: "80%", color: "#ff3d60"}}>{props.text}</span>
  
  useEffect(() => {
    getUserBankAccounts(data["user_reference_number"])
      .then((res) => {
        if (
          res.success &&
          res.data &&
          res.data["bank_account"] &&
          res.data["bank_account"].length
        ) {
          let bankDetails = {};
          let bankReferenceMapping = {}
          res.data["bank_account"].forEach((bank) => {
            bankDetails[bank["user_bank_reference_number"]] = `${bank["bank_account_no"]} / ${bank["bank_name"]} / ${bank["bank_branch_ifsc"]}`;
            bankReferenceMapping[bank["user_bank_reference_number"]] = {
              user_bank_reference_number: bank.user_bank_reference_number,
            };
          });

          setBankAccounts(bankDetails);
          setUserBankReferenceNumber(bankReferenceMapping);

        }
      })
      .catch((error) => {});
      // eslint-disable-next-line
  }, []);
    const handleClickOnAddBank = (setFieldValue) =>{
      setOpenAddBankDetails(true)
      setFieldValue('user_bank_reference_number', "")
    }
    const handleClickOnCloseBankCard = (setFieldValue) =>{
      setOpenAddBankDetails(false)
      setFieldValue('bank_account_no', '');
      setFieldValue('bank_account_holder_name', '');
      setFieldValue('bank_branch_ifsc', '');
      setFieldValue('user_bank_reference_number', "")
    }

    const handleIFSCChange = async (e,setFieldValue) => {
      const bankIfscCode = e?.target?.value;
        setFieldValue('bank_branch_ifsc', bankIfscCode);

        if (!bankIfscCode) {
          setBankInfo(null);
          setFieldValue('bank_name', '');
          return;
        }

      if (bankIfscCode?.length === 11) {
        try {
          const res = await getBanks(bankIfscCode);
          setBankInfo(res?.data);
          setFieldValue('bank_name', res?.data?.bank_name)

        } catch (err) {
          setBankInfo(null);
          setFieldValue('bank_name', '');
        }
      }else {
        setBankInfo(null);
        setFieldValue('bank_name', '');
      }
    };

  return (
    <Formik
      initialValues={{
        refund_mode_requested: isRefundView ? mode : "ORIGINAL_MODE_OF_PAYMENT",
        user_bank_reference_number: bankAccountDetails?.user_bank_reference_number || "",
        user_bank_reference_number: isRefundView ? bankAccountDetails?.user_bank_reference_number || "" : "",
        refund_amount: data["extra_payment_amount"],
        bank_account_no:"",
        bank_account_holder_name:"",
        bank_branch_ifsc:"",
        bank_micr_code:"",
      }}
      validationSchema={openAddBankDetails? addBankSchema : Schema}
        onSubmit={async (values, { setSubmitting }) => {
         let reqData = {};
            reqData["refund_mode_requested"] = values["refund_mode_requested"];

            if (isRefundView) {
              reqData["payment_reference_number"] = data["payment_reference_number"];
            } else {
              reqData["refunded_amount"] = values["refund_amount"];
            }

            if (values["refund_mode_requested"] === "NEFT") {
              reqData["user_bank_reference_number"] = values["user_bank_reference_number"];

              if (values["refund_mode_requested"] === "NEFT" && openAddBankDetails) {
                reqData["bank_account_no"] = values["bank_account_no"];
                reqData["bank_account_holder_name"] = values["bank_account_holder_name"];
                reqData["bank_branch_ifsc"] = values["bank_branch_ifsc"];
                reqData["user_reference_number"] = data["user_reference_number"]
                reqData["add_flag"] = true;
                reqData["remarks"] = "MANUAL_ADDED_BANK";
              } else {
                reqData["add_flag"] = false;
                reqData["remarks"] = "";
              }
            } 
          if(isRefundView){ 
               let res = await updateRefundBank(
              refund_reference_number,
              reqData
            );
            if (res.success) {
              toastSuccess(res.message);
              handleClose(true);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            } else {
              toastWarning(res.message);
            }
            setSubmitting(false);
          }
          else{
            let res = await createRefundEntry(
              data["payment_reference_number"],
              reqData
            );
            if (res.success) {
              toastSuccess(res.message);
              handleClose(true);
            } else {
              toastWarning(res.message);
            }
            setSubmitting(false);
          }
      }}

    >
      {({
        isValid,
        isSubmitting,
        handleSubmit,
        values,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
        errors,
        ...allprops
      }) => {
        return (
          <Spin spinning={isSubmitting}>
            <form
              // className={classes.form}
              noValidate
              method="POST"
              onSubmit={handleSubmit}
            >
              {!isMobile ? 
              <DialogContent
                dividers={false}
                style={{
                  backgroundColor: Colors["lighterPurple"],
                  fontSize: "0.8125rem",
                  // minWidth: "40vw",
                }}
              >
                <div className="flex-spacing" style={{ margin: "1rem 0px" }}>
                  <Card>
                    <CardContent>
                      <TableContainer>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TCell style={{ width: "30%" }}>
                              Refund Model Requested
                            </TCell>
                            <TCell style={{paddingRight:'20px'}}>
                              <MNativeSelect
                                // onChange={handleChange}
                                onChange={(e) => {
                                  const {value} = e.target;
                                  setFieldValue("refund_mode_requested",value); 
                                  setOpenAddBankDetails(false)
                                }}
                              
                                style={{ width: "100%" }}
                                name="refund_mode_requested"
                                value={values.refund_mode_requested}
                                options={{
                                  ORIGINAL_MODE_OF_PAYMENT:
                                    "ORIGINAL_MODE_OF_PAYMENT",
                                  NEFT: "NEFT",
                                }}
                              />
                            </TCell>
                            {isMobile ? null : 
                            values.refund_mode_requested === "NEFT"? 
                            <TCell style={{width: "15%"}}>
                            <Button 
                              className="addBankBtn"
                              onClick={() => handleClickOnAddBank(setFieldValue)}
                            >
                              Add Bank
                            </Button>
                            </TCell> : null}
                          </TableBody>
                          <TableBody></TableBody>
                          {values?.refund_mode_requested === "NEFT"  && !openAddBankDetails ? (
                            <TableBody>
                              <TCell style={{ width: "30%" }}>
                                Bank Details
                              </TCell>
                              <TCell style={{paddingRight:'20px'}}>
                                <MNativeSelect
                                  onChange={(e) => {
                                    const selectedBankId = e.target.value;
                                    if (userBankReferenceNumber[selectedBankId]) {
                                      const selectedBank = userBankReferenceNumber[selectedBankId];
                                      setFieldValue("user_bank_reference_number", selectedBank.user_bank_reference_number);
                                      setFieldValue("user_bank_reference_number", selectedBank.user_bank_reference_number);
                                    }
                                  }}
                                  nulloption="Select"
                                  style={{ width: "100%" }}
                                  name="user_bank_reference_number"
                                  value={values.user_bank_reference_number}
                                  options={bankAccounts}
                                />
                                 {values?.refund_mode_requested === 'NEFT' &&  touched?.user_bank_reference_number &&
                                  !values?.user_bank_reference_number && 
                                  errors?.user_bank_reference_number && (
                                    <ErrorText text={errors?.user_bank_reference_number} />
                                  )}
                              </TCell>
                            </TableBody>
                          ) : null}
                          {isRefundView ? null : 
                          <TableBody>
                            <TCell>Refund Amount</TCell>
                            <TCell>
                              <CustomInput
                                style={{
                                  width: "100%",
                                }}
                                type="number"
                                textFiledStyle={{ width: "100%" }}
                                name="refund_amount"
                                value={values.refund_amount}
                                onChange={handleChange}
                                placeholder="Refund Amount"
                              />
                            </TCell>
                          </TableBody> }
                        

                        </Table>
                      </TableContainer>
                    </CardContent>
                    {openAddBankDetails && values?.refund_mode_requested != "ORIGINAL_MODE_OF_PAYMENT" ?
                          <CardContent className="userBankDetails">
                            <div className="heading">
                              <div className="title">User Bank Details Edit</div>
                               <IconButton aria-label="close" onClick={() => handleClickOnCloseBankCard(setFieldValue)}>
                                  <CloseIcon />
                                </IconButton>
                              </div>                      
                            <Grid item xs={12} >
                            <Field
                            style={{ marginBottom: '0px' }}
                            variant="outlined"
                            className="inputField"
                            margin="normal"
                            fullWidth
                            required
                            id="bank_branch_ifsc"
                            label="IFSC Code"
                            placeholder="IFSC Code"
                            name="bank_branch_ifsc"
                            component={InputField}
                            onChange={(e) => handleIFSCChange(e, setFieldValue)}
                          />
                            </Grid>
                            <Grid item xs={12}>
                              <Select
                                  styles={customStyles}
                                  label="Is Account type"
                                  placeholder="Select Bank"
                                  isSearchable={true}
                                  isDisabled={true}
                                  options={[{ value: bankInfo?.bank_name, label: bankInfo?.bank_name }]}
                                  value={{ value: bankInfo?.bank_name, label: bankInfo?.bank_name }}
                                  id="bank_name"
                                  name="bank_name"
                                  isLoading={false}
                                  loadingMessage={() => "Fetching bank_name"}
                                  noOptionsMessage={() => "No Options Available"}
                                  
                              />
                            </Grid>
                            <Grid item xs={12} >
                              <Field
                                    style={{marginBottom:'0px'}}
                                    className="inputField"
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    required
                                    id="bank_account_no"
                                    label="Account Number"
                                    placeholder="Account Number"
                                    name="bank_account_no"
                                    component={InputField}
                                    inputProps={{
                                      maxLength: 20
                                    }}
                                    touched={touched}
                                    onKeyPress={(e) => {
                                      if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                              <Field
                                    style={{marginBottom:'0px'}}
                                    variant="outlined"
                                    className="inputField"
                                    margin="normal"
                                    fullWidth
                                    required
                                    inputProps={{ maxLength: 50 }}
                                    id="bank_account_holder_name"
                                    label="Account Holder Name"
                                    placeholder="Account Holder Name"
                                    name="bank_account_holder_name"
                                    component={InputField}
                                    touched={touched}
                                     onKeyPress={(e) => {
                                      if (!/^[A-Za-z\s]*$/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                />
                            </Grid>
                          </CardContent>
                          : null}
                  </Card>
                </div>
              </DialogContent>
                :
              <DialogContent
                dividers={false}
                style={{
                  backgroundColor: Colors["lighterPurple"],
                  fontSize: "0.8125rem",
                  padding: "0px 24px"
                }}
              >
                <div className="flex-spacing">
                  <Card>
                    <CardContent className="refundTableCard">
                      <TableContainer>
                        <Table size="small" aria-label="simple table">
                        <TableBody >
                            <TCell style={{ width: "100%", paddingBottom:"14px" }}>
                              Refund Model Requested
                              </TCell>
                            </TableBody>
                            <TableBody>
                            <TCell style={{ width: "100%" }}>
                            <MNativeSelect
                                // onChange={handleChange}
                                onChange={(e) => {
                                  const {value} = e.target;
                                  setFieldValue("refund_mode_requested",value); 
                                  setOpenAddBankDetails(false)
                                }}                            
                                style={{ width: "100%",height:'40px' }}
                                name="refund_mode_requested"
                                value={values.refund_mode_requested}
                                options={{
                                  ORIGINAL_MODE_OF_PAYMENT:
                                    "ORIGINAL_MODE_OF_PAYMENT",
                                  NEFT: "NEFT",
                                }}
                              />
                              </TCell>
                            </TableBody>
                            {values?.refund_mode_requested === "NEFT"  && !openAddBankDetails? (
                              <>
                            <TableBody>
                              <TCell style={{ width: "30%",paddingBottom:"14px" }}>
                                Bank Details
                              </TCell>
                            </TableBody>
                            <TableBody>                              
                              <TCell>
                                <MNativeSelect
                                  onChange={(e) => {
                                    const selectedBankId = e.target.value;
                                    if (userBankReferenceNumber[selectedBankId]) {
                                      const selectedBank = userBankReferenceNumber[selectedBankId];
                                      setFieldValue("user_bank_reference_number", selectedBank.user_bank_reference_number);
                                      setFieldValue("user_bank_reference_number", selectedBank.user_bank_reference_number);
                                    }
                                  }}
                                  nulloption="Select"
                                  style={{ width: "100%" }}
                                  name="user_bank_reference_number"
                                  value={values.user_bank_reference_number}
                                  options={bankAccounts}
                                />
                                   {values?.refund_mode_requested === 'NEFT' && touched?.user_bank_reference_number &&
                                    !values?.user_bank_reference_number && 
                                    errors?.user_bank_reference_number && (
                                      <ErrorText text={errors?.user_bank_reference_number} />
                                    )}
                              </TCell>
                            </TableBody>
                            </>
                          ) : null}
                          
                          {isRefundView ? null : 
                          <>
                           <TableBody>
                            <TCell style={{paddingBottom:"14px"}}>Refund Amount</TCell>
                          </TableBody>
                          <TableBody>
                          <TCell>
                              <CustomInput
                                className="refundInput"
                                type="number"
                                textFiledStyle={{ width: "100%" }}
                                name="refund_amount"
                                value={values.refund_amount}
                                onChange={handleChange}
                                placeholder="Refund Amount"
                              />
                            </TCell>
                          </TableBody>
                          </>}
                          <TableBody>
                            <TCell>
                              {isMobile ?  
                                values?.refund_mode_requested === "NEFT"? 
                                <TCell style={{width: "15%",paddingTop:'10px'}}>
                                <Button 
                                  className="mobileAddBankBtn"
                                  onClick={() => handleClickOnAddBank(setFieldValue)}
                                >
                                  Add Bank
                                </Button>
                                  </TCell> 
                              : null : null}
                            </TCell>
                            </TableBody>
                          </Table>
                      </TableContainer>
                    </CardContent>

                    {openAddBankDetails && values?.refund_mode_requested != "ORIGINAL_MODE_OF_PAYMENT" ?
                          <CardContent className="userBankDetails">
                            <div className="heading">
                              <div className="title">User Bank Details Edit</div>
                              <IconButton aria-label="close" onClick={() => handleClickOnCloseBankCard(setFieldValue)}>
                                  <CloseIcon />
                                </IconButton>
                            </div>                      
                            <Grid item xs={12} >
                              <Field
                                    style={{marginBottom:'0px'}}
                                    variant="outlined"
                                    className="inputField"
                                    margin="normal"
                                    fullWidth
                                    required
                                    id="bank_branch_ifsc"
                                    label="IFSC Code"
                                    placeholder="IFSC Code"
                                    name="bank_branch_ifsc"
                                    component={InputField}
                                    touched={touched}
                                    onChange={(e) => handleIFSCChange(e, setFieldValue)}
                                    />
                            </Grid>
                            <Grid item xs={12}>
                              <Select
                                  styles={customStyles}
                                  label="Is Account type"
                                  placeholder="Select Bank"
                                  isSearchable={true}
                                  options={[{ value: bankInfo?.bank_name, label: bankInfo?.bank_name }]}
                                  value={{ value: bankInfo?.bank_name, label: bankInfo?.bank_name }}
                                  id="bank_name"
                                  name="bank_name"
                                  isLoading={false}
                                  loadingMessage={() => "Fetching bank_name"}
                                  noOptionsMessage={() => "No Options Avail able"}
                              />
                            </Grid>
                            <Grid item xs={12} >
                              <Field
                                    style={{marginBottom:'0px'}}
                                    className="inputField"
                                    variant="outlined"
                                    margin="normal"
                                    fullWidth
                                    required
                                    inputProps={{
                                      maxLength: 20
                                    }}
                                    id="bank_account_no"
                                    label="Account Number"
                                    placeholder="Account Number"
                                    name="bank_account_no"
                                    component={InputField}
                                    touched={touched}
                                />
                            </Grid>
                            <Grid item xs={12} >
                              <Field
                                    style={{marginBottom:'0px'}}
                                    variant="outlined"
                                    className="inputField"
                                    margin="normal"
                                    fullWidth
                                    required
                                    inputProps={{ maxLength: 50 }}
                                    id="bank_account_holder_name"
                                    label="Account Holder Name"
                                    placeholder="Account Holder Name"
                                    name="bank_account_holder_name"
                                    component={InputField}
                                    touched={touched}
                                />
                            </Grid>
                          </CardContent>
                          : null}
                  </Card>
                </div>
                </DialogContent>
              }
                <DialogActions style={{padding:'20px'}}> 
                <Button
                  //   onClick={verifyPaymentHandler}
                  color="primary"
                  variant="contained"
                  className="shadow-none common_kissht_btn"
                  type="submit"
                  // disabled={isSubmitting || !isValid}
                >
                  Submit
                </Button>
                <Button 
                  onClick={handleClose}
                  variant="contained"
                  className="shadow-none common_kissht_btn"
                  // disabled={isSubmitting || !isValid}
                >
                  Close
                </Button>
              </DialogActions>               
            </form>
          </Spin>
        );
      }}
    </Formik>
  );
};
